import { ApiCore } from '@/services/api/utils/core.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = 'sys'
const plural = 'systems'
const single = 'system'

const api = new ApiCore({
	index: true,
	findAll: true,
	url: url,
	plural: plural,
	single: single
})


api.getPitstops = (option) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/pitstops`, option)
		.then(handleResponse)
		.catch(handleError);
}


export default api
